import { render, staticRenderFns } from "./ImportCalendar.vue?vue&type=template&id=4b488869"
import script from "./ImportCalendar.vue?vue&type=script&lang=js"
export * from "./ImportCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports